export default "__VITE_ASSET__670829f6__"